import React, { createContext, useContext, useState, useCallback } from 'react';
import T, { detectLanguage } from '../i18n/translations';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => detectLanguage());

  const setLang = useCallback((code) => {
    localStorage.setItem('biomall_lang', code);
    setLangState(code);
  }, []);

  const t = T[lang] || T.en;
  const isRTL = lang === 'ar';

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, isRTL }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}
